import {takeEvery, call} from 'redux-saga/effects';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {GetSearchUsersAction} from './actions';

import {
    SEARCH_USER_REQUEST
} from './constants';

function* searchUserFetch(action: GetSearchUsersAction) {
    try {
        const data = yield call(Api.fetch, {
            endpoint: action.endpoint,
            method: ApiMethods.GET
        });
        action.getUsers(data.responseData);
    } catch (e) {
        action.setError();
    }
}

export function* searchUserSaga() {
    yield takeEvery(SEARCH_USER_REQUEST, searchUserFetch);
}
